import React from 'react';

const useCases = [
  {
    icon: '🎓',
    title: 'Aerospace Students',
    description: 'Prototype CubeSat and academic mission transfer scenarios.'
  },
  {
    icon: '🚀',
    title: 'Space Startups',
    description: 'Estimate ΔV budgets and validate feasibility before full-scale mission design.'
  },
  {
    icon: '🛰️',
    title: 'Satellite Engineers',
    description: 'Compare transfer strategies and analyze maneuver trade-offs rapidly.'
  },
  {
    icon: '💻',
    title: 'Developers',
    description: 'Integrate orbital transfer computation directly into custom software via API.'
  }
];

const UseCasesSection = () => {
  return (
    <section className="py-20 px-4 bg-dark-900/50">
      <div className="max-w-6xl mx-auto">

        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold mb-4">Built For</h2>
          <p className="text-gray-400 text-lg">
            From students to space startups
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {useCases.map((item, index) => (
            <div
              key={index}
              className="bg-dark-800 p-6 rounded-lg border border-gray-700 hover:border-primary-500 transition"
            >
              <div className="text-3xl mb-3">{item.icon}</div>
              <h3 className="text-xl font-semibold mb-2 text-white">
                {item.title}
              </h3>
              <p className="text-gray-400">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default UseCasesSection;